import { REGEX } from '../../../Helpers/constant';
import { EventFormJson } from './interfaces';

export const formJsonStep1: Array<EventFormJson> = [
  {
    grid: {
      md: 12,
      lg: 12,
      xs: 12,
    },
    rows: [
      {
        grid: {
          md: 12,
          lg: 12,
          xs: 12,
        },
        fields: [
          {
            type: 'coverField',
            name: 'coverImage',
            acceptFiles: ['image/jpeg', 'image/png', 'image/jpg'],
            accept: 'image/jpeg,image/png,image/jpg',
            label: 'Choose a cover photo',
            maxSize: 1,
            description: 'Max image size: 2 MB | Min width: 1028px | Image format: PNG, JPEG',
          },
        ],
      },
    ],
  },
  {
    grid: { md: 12, lg: 12, xs: 12 },
    rows: [
      {
        grid: { md: 6, lg: 6, xs: 12 },
        fields: [
          {
            type: 'text',
            remaining: false,
            placeholder: 'Event title will be visible in the platform',
            name: 'eventTitle',
            height: '60px',
            hideLabel: false,
            label: 'Event title',
            validation: {
              required: 'This field is required',
              minLength: {
                value: 1,
                message: 'This field must be at least 1 characters',
              },
              maxLength: {
                value: 100,
                message: 'This field cannot be more than 100 characters',
              },
            },
          },
          {
            type: 'autoComplete',
            name: 'category',
            options: [
              {
                label: 'Seminar',
                value: 'Seminar',
              },
              {
                label: 'Conference',
                value: 'Conference',
              },
              {
                label: 'Virtual Submits',
                value: 'Virtual Submits',
              },
              {
                label: 'Religious Gathering',
                value: 'Religious Gathering',
              },
            ],
            remaining: false,
            placeholder: 'Event categories',
            height: '60px',
            hideLabel: true,
            label: 'Event Category',
          },
          {
            type: 'text',
            name: 'maximumNumberofParticipants',
            remaining: false,
            placeholder: 'Number of participants expected',
            height: '60px',
            hideLabel: false,
            label: 'Maximum number of participants',
            validation: {
              required: 'This field is required',
              pattern: {
                value: /^[0-9]+$/,
                message: 'Please enter a valid number without symbols',
              },
            },
            onKeyDown: (e) => {
              if (!/^[0-9]$/.test(e.key) && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
                e.preventDefault();
              }
            },
          },
          {
            type: 'autoComplete',
            name: 'timezone',
            options: [
              {
                label: 'India Standard Time (IST)',
                value: 'India Standard Time (IST)',
              },
              {
                label: 'United States Standard Time (US)',
                value: 'United States Standard Time (US)',
              },
            ],
            remaining: false,
            placeholder: 'Event timezone',
            height: '60px',
            hideLabel: true,
            label: 'Event timezone',
          },
          {
            type: 'textarea',
            name: 'description',
            remaining: false,
            placeholder: 'Even description will be visible in platform',
            rows: 2,
            hideLabel: false,
            multiline: true,
            label: 'Description',
            showCharCount: true,
            validation: {
              required: 'This field is required',
              minLength: {
                value: 10,
                message: 'This field must be at least 10 characters',
              },
              maxLength: {
                value: 1000,
                message: 'This field cannot be more than 1000 characters',
              },
            },
          },
          
        ],
      },
      {
        grid: { md: 6, lg: 6, xs: 12 },
        fields: [
          {
            type: 'autoComplete',
            name: 'suitablefor',
            remaining: false,
            options: [
              { label: 'Alumni', value: 'Alumni' },
              { label: 'Teachers', value: 'Teachers' },
              { label: 'Designers', value: 'Designers' },
            ],
            placeholder: 'Target audience',
            height: '60px',
            hideLabel: true,
            label: 'Suitable for',
          },
          {
            type: 'autoComplete',
            name: 'languageOfDelivery',
            options: [
              { label: 'English', value: 'English' },
              { label: 'Hindi', value: 'Hindi' },
              { label: 'French', value: 'French' },
            ],
            remaining: false,
            placeholder: 'Select languages',
            height: '60px',
            hideLabel: true,
            label: 'Language of delivery',
          },
          {
            type: 'upload',
            remaining: false,
            name: 'eventBroucher',
            maxSize: 1,
            acceptFiles: ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'],
            accept: 'image/jpeg,image/png,image/jpg,application/pdf',
            label: 'Upload brochure for the event (optional)',
            hideLabel: true,
            placeholder: 'Upload brochure',
            id: 'upload',
          },
          {
            type: 'text',
            name: 'targetKeywords',
            remaining: false,
            hideLabel: false,
            label: 'What can the participants expect from the event?',
            validation: {
              minLength: {
                value: 1,
                message: 'This field must be at least 1 characters',
              },
              maxLength: {
                value: 100,
                message: 'This field cannot be more than 100 characters',
              },
            },
          },
          {
            type: 'textarea',
            name: 'agenda',
            multiline: true,
            remaining: false,
            rows: 2,
            hideLabel: false,
            label: 'Agenda',
            validation: {
              minLength: {
                value: 1,
                message: 'This field must be at least 1 characters',
              },
              maxLength: {
                value: 100,
                message: 'This field cannot be more than 100 characters',
              },
            },
          },
        ],
      },
    ],
  },
];

export const sessionDetails: Array<EventFormJson> = [
  {
    grid: {
      lg: 12,
      md: 12,
      xs: 12,
    },
    metaData: {
      fieldsToShow: [
        {
          label: 'Session title',
          type: 'text',
          name: 'sessionTitle',
        },
        {
          label: 'Time range',
          type: 'timeRange',
          name: ['startDate', 'endDate'],
        },
        {
          label: 'Name of the speaker',
          type: 'array',
          name: 'speakers',
        },
      ],
    },
    rows: [
      {
        grid: {
          md: 12,
          lg: 6,
          xs: 12,
        },
        fields: [
          {
            type: 'text',
            name: 'sessionTitle',
            placeholder: 'Give a title for your session',
            label: 'Session title',
            height: '60px',
            validation: {
              required: 'This field is required',
              minLength: { value: 1, message: 'This field must be at least 1 characters' },
              maxLength: { value: 100, message: 'This field cannot be more than 100 characters' },
            },
          },
          {
            type: 'textarea',
            multiline: true,
            rows: 2,
            label: 'Agenda',
            name: 'sessionAgenda',
            placeholder: 'Outline session expectation',
            validation: { required: 'This field is required' },
          },
          {
            type: 'select',
            name: 'timezone',
            options: [
              {
                label: 'India Standard Time (IST)',
                value: 'India Standard Time (IST)',
              },
              {
                label: 'United States Standard Time (US)',
                value: 'United States Standard Time (US)',
              },
            ],
            remaining: false,
            placeholder: 'Section timezone',
            height: '60px',
            hideLabel: true,
            label: 'Section timezone',
          },
        ],
      },
      {
        grid: {
          md: 12,
          lg: 6,
          xs: 12,
        },
        fields: [
          {
            type: 'timeRange',
            name: 'sessionTimeRange',
            label: 'Select time range',
            hideLabel: true,
            placeholder: 'Give a title for your session',
            height: '60px',
            validation: {
              required: 'This field is required',
            },
          },
          {
            type: 'upload',
            name: 'sessionBroucher',
            hideLabel: true,
            id: 'sessionBrochure',
            acceptFiles: ['image/jpeg', 'image/png', 'image/jpg'],
            accept: 'image/*',
            maxSize: 1,
            label: 'Upload brochure for the session (optional)',
            placeholder: 'Upload an image of the speaker',
          },
        ],
      },
    ],
  },
];

export const speakerDetails: Array<EventFormJson> = [
  {
    grid: {
      lg: 12,
      md: 12,
      xs: 12,
    },
    metaData: {
      fieldsToShow: [
        {
          label: 'Name',
          type: 'text',
          name: 'speakerName',
        },
        {
          label: 'Image of the speaker',
          type: 'img',
          name: 'speakerImage',
        },
        {
          label: 'Description',
          type: 'text',
          name: 'descriptionAboutTheSpeaker',
        },
      ],
    },
    rows: [
      {
        grid: {
          md: 12,
          lg: 6,
          xs: 12,
        },
        fields: [
          {
            type: 'select',
            name: 'speakerName',
            label: 'Name of the speaker*',
            placeholder: 'Enter full name',
            height: '60px',
            optionsMeta: {
              fieldName: 'contacts',
              objectName: 'contacts',
            },
            hideLabel: true,
            withSearch: true,
            enableValuepreview: true,
            options: [],
            validation: {
              required: 'This field is required',
            },
          },
          {
            type: 'textarea',
            name: 'descriptionAboutTheSpeaker',
            label: 'Description about the speaker',
            placeholder: 'Help audience get to know he speaker',
            height: '60px',
            validation: {
              maxLength: {
                value: 100,
                message: 'This field cannot be more than 100 characters',
              },
            },
          },
        ],
      },
      {
        grid: {
          md: 12,
          lg: 6,
          xs: 12,
        },
        fields: [
          {
            type: 'upload',
            name: 'speakerImage',
            hideLabel: true,
            id: 'speakerImage',
            maxSize: 1,
            acceptFiles: ['image/jpeg', 'image/png', 'image/jpg'],
            accept: 'image/*',
            label: 'Image of the speaker (optional)',
            placeholder: 'Upload an image of the speaker',
            height: '60px',
          },
        ],
      },
    ],
  },
];

export const locationDetails: Array<EventFormJson> = [
  {
    grid: {
      lg: 12,
      md: 12,
      xs: 12,
    },
    rows: [
      {
        grid: {
          md: 12,
          lg: 12,
          xs: 12,
        },
        fields: [
          {
            type: 'radio',
            name: 'locationType',
            label: 'Select location type',
            radioGroupProps: {
              row: true,
            },
            hideLabel: true,
            radioOptions: [
              { value: 'Online event', label: 'Online event' },
              { value: 'OnSite', label: 'On-site' },
              { label: 'Hybrid', value: 'Hybrid' },
            ],
            validation: {
              required: 'This field is required',
            },
          },
        ],
      },
      {
        grid: {
          md: 6,
          lg: 6,
          xs: 12,
        },
        fields: [
          {
            type: 'textarea',
            name: 'locationAddress',
            rows: 4,
            multiline: true,
            visible: false,
            hideLabel: true,
            rule: { key: 'locationType', modifyKey: 'visible', value: 'Hybrid', operation: 'VISIBLE', modifyValue: true },
            placeholder: 'Enter address to the session venue',
            validation: {
              required: 'This field is required',
            },
          },
        ],
      },
      {
        grid: {
          md: 6,
          lg: 6,
          xs: 12,
        },
        fields: [
          {
            type: 'text',
            name: 'sessionLink',
            height: '60px',
            hideLabel: true,
            placeholder: 'Paste event link',
            rule: { key: 'locationType', modifyKey: 'visible', value: 'Hybrid', operation: 'VISIBLE', modifyValue: true },
            validation: {
              pattern: {
                value: REGEX.HTTPS,
                message: 'Please enter a valid URL',
              },
              required: 'This field is required',
            },
          },
        ],
      },
      {
        grid: {
          md: 6,
          lg: 6,
          xs: 12,
        },
        fields: [
          {
            type: 'textarea',
            name: 'locationAddress',
            rows: 4,
            multiline: true,
            visible: false,
            hideLabel: true,
            rule: { key: 'locationType', modifyKey: 'visible', value: 'OnSite', operation: 'VISIBLE', modifyValue: true },
            placeholder: 'Enter address to the session venue',
            validation: {
              required: 'This field is required',
            },
          },
        ],
      },
      {
        grid: {
          md: 12,
          lg: 6,
          xs: 12,
        },
        fields: [
          {
            type: 'none',
          },
        ],
      },
      {
        grid: {
          md: 6,
          lg: 6,
          xs: 12,
        },
        fields: [
          {
            type: 'text',
            name: 'sessionLink',
            height: '60px',
            hideLabel: true,
            placeholder: 'Paste event link',
            rule: { key: 'locationType', modifyKey: 'visible', value: 'Online event', operation: 'VISIBLE', modifyValue: true },
            validation: {
              pattern: {
                value: REGEX.HTTPS,
                message: 'Please enter a valid URL',
              },
              required: 'This field is required',
            },
          },
        ],
      },
    ],
  },
];
